<serviceos-ng-card *ngIf="accountSettingsConfig$ | async as accountSettingsConfig">
    <span class="title">{{accountSettingsConfig.title}}</span>
    <div class="content">
        <p class="description" *ngIf="accountSettingsConfig.description">{{ accountSettingsConfig.description }}</p>
        <serviceos-web-avatar-form *ngIf="accountSettingsConfig.avatar"></serviceos-web-avatar-form>
        <serviceos-web-name-form *ngIf="accountSettingsConfig.names"></serviceos-web-name-form>
        <serviceos-web-password-form *ngIf="accountSettingsConfig.password && !accountSettingsConfig.password.disable"></serviceos-web-password-form>
        <ng-container *ngIf="(birthday_disable$ | async) === false || (birthday_disable$ | async) === undefined">
            <serviceos-web-birthdate-form *ngIf="accountSettingsConfig.birthday"></serviceos-web-birthdate-form>
        </ng-container>
    </div>
</serviceos-ng-card>